var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"small":"","color":!_vm.value ? 'red' : 'green'}},[_vm._v(" "+_vm._s(_vm.value ? 'mdi-check' : 'mdi-close')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }